import request from '@/utils/request';

export function cardListApi(data) {
	return request({
		url: '/card/list',
		method: 'get',
		params: data
	});
}

export function cardDetailApi(data) {
	return request({
		url: '/card/detail',
		method: 'get',
		params: data
	});
}
